import React, { useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import { useDispatch } from "react-redux";
import {
  userSignUp,
  sendSignupOtp,
  verifySignupOtp,
} from "../../../../features/auth/authSlice";
import { RegxExpression } from "../../../../utils/common";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import OtpInput from "react-otp-input";
const SignUp_Modal = ({
  onHide,
  setShowAccountCreted,
  showSignUp,
  setShowSignUp,
}) => {
  // const [showSignUp, setShowSignUp] = useState(false);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [isSigningUp, setIsSigningUp] = useState(false);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    if (isSigningUp) return;

    // Mobile OTP verification is mandatory
    if (!otpVerified) {
      setOtpError("Please verify your mobile number first.");
      return;
    }

    // Since contact_no input is disabled after OTP is sent,
    // explicitly make sure it is included in signup data.
    data.contact_no = mobileNumber;

    setIsSigningUp(true);

    try {
      const res = await dispatch(userSignUp(data));

      if (res.meta?.requestStatus === "fulfilled") {
        onHide();
        setShowAccountCreted();
      } else if (res.meta?.requestStatus === "rejected") {
        if (res.payload?.errors?.email) {
          setError("email", {
            type: "manual",
            message: res.payload?.errors?.email,
          });
        }

        if (res.payload?.errors?.contact_no) {
          setError("contact_no", {
            type: "manual",
            message: res.payload?.errors?.contact_no,
          });
        }
      }
    } finally {
      setIsSigningUp(false);
    }
  };

  /* new  */
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState("");

  const mobileNumber = watch("contact_no");

  const handleSendOtp = async () => {
    setOtpError("");

    const isValid = await trigger("contact_no");

    if (!isValid) {
      return;
    }

    setOtpSending(true);

    try {
      const res = await dispatch(
        sendSignupOtp({
          contact_no: mobileNumber,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpSent(true);
        setOtp("");
        setOtpVerified(false);
        setOtpError("");
      } else {
        const errorData = res.payload;

        setOtpSent(false);

        if (errorData?.errors) {
          setError("contact_no", {
            type: "manual",
            message: errorData.errors,
          });
        } else if (errorData?.contact_no) {
          setError("contact_no", {
            type: "manual",
            message: errorData.contact_no,
          });
        } else if (errorData?.message) {
          setError("contact_no", {
            type: "manual",
            message: errorData.message,
          });
        } else if (typeof errorData === "string") {
          setError("contact_no", {
            type: "manual",
            message: errorData,
          });
        } else {
          setError("contact_no", {
            type: "manual",
            message: "Failed to send OTP",
          });
        }
      }
    } finally {
      setOtpSending(false);
    }
  };

  const handleVerifyOtp = async () => {
    setOtpError("");

    if (otp.length !== 4) {
      setOtpError("Please enter the 4 digit OTP.");
      return;
    }

    setOtpVerifying(true);

    try {
      const res = await dispatch(
        verifySignupOtp({
          contact_no: mobileNumber,
          otp: otp,
        }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpVerified(true);
        setOtpError("");
      } else {
        setOtpVerified(false);

        const errorData = res.payload;

        if (errorData?.errors) {
          setOtpError(errorData.errors);
        } else if (typeof errorData === "string") {
          setOtpError(errorData);
        } else {
          setOtpError("Invalid OTP");
        }
      }
    } finally {
      setOtpVerifying(false);
    }
  };

  return (
    <div className="signup_div">
      <div className="login_form_div">
        <Form>
          <Form.Group className="gray_input_group input_group">
            <Form.Group className="gray_input_group input_group">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Full name"
                // {...register("name", {
                //   required: "Name is required",

                //   maxLength: {
                //     value: 100,
                //     message: "Name cannot exceed 100 characters"
                //   }
                // })}
                {...register("name", {
                  required: "Name is required",
                  maxLength: {
                    value: 100,
                    message: "Name cannot exceed 100 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
                    message:
                      "Name can contain only alphabets with single spaces",
                  },
                  onChange: (e) => {
                    let value = e.target.value;

                    // Remove anything except alphabets and spaces
                    value = value.replace(/[^A-Za-z ]/g, "");

                    // Prevent multiple spaces
                    value = value.replace(/\s{2,}/g, " ");

                    // Prevent leading space
                    value = value.replace(/^\s+/, "");

                    setValue("name", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                })}
              />
              {errors?.name && (
                <sup className="text-danger">{errors?.name?.message}</sup>
              )}
            </Form.Group>
            <Form.Label>Email </Form.Label>
            <Form.Control
              type="text"
              name="email"
              placeholder="Enter Email"
              {...register("email", {
                required: "Email Id is required",

                maxLength: {
                  value: 100,
                  message: "Email cannot exceed 100 characters",
                },
                pattern: {
                  value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                  message: "Please enter a valid email address",
                },
                onChange: (e) => {
                  // const value = e.target.value.trimStart();

                  let value = e.target.value;

                  // Prevent multiple spaces
                  value = value.replace(/\s{2,}/g, " ");

                  // Prevent leading space
                  value = value.replace(/^\s+/, "");

                  setValue("email", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              })}
            />
            {errors?.email && (
              <sup className="text-danger">{errors?.email?.message}</sup>
            )}
          </Form.Group>

          {/* <Form.Group className="gray_input_group input_group">
            <Form.Label>Mobile Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter mobile number"
              maxLength={10}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault(); // Block non-numeric input
                }
              }}
              {...register("contact_no", {
                required: "Mobile Number is required",
                pattern: {
                  value: /^[6-9][0-9]{9}$/,
                  message: "Please enter a valid 10 digit mobile number",
                },
                onChange: (e) => {
                  let value = e.target.value.replace(/\D/g, "");

                  // Maximum 10 digits
                  value = value.slice(0, 10);

                  setValue("contact_no", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              })}
            />
            {errors?.contact_no && (
              <sup className="text-danger">{errors?.contact_no?.message}</sup>
            )}
          </Form.Group> */}
          <Form.Group className="gray_input_group input_group new-wrappp">
            <Form.Label>Mobile Number</Form.Label>

            <div className="d-flex gap-2">
              <Form.Control
                type="text"
                placeholder="Enter mobile number"
                maxLength={10}
                disabled={otpSent}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                {...register("contact_no", {
                  required: "Mobile Number is required",
                  pattern: {
                    value: /^[6-9][0-9]{9}$/,
                    message: "Please enter a valid 10 digit mobile number",
                  },
                  onChange: (e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    value = value.slice(0, 10);

                    clearErrors("contact_no");

                    setValue("contact_no", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                })}
              />

              {otpVerified ? (
                <span className="text-success fw-semibold">Verified</span>
              ) : (
                <Green_btn
                  disabled={
                    otpSending ||
                    !/^[6-9][0-9]{9}$/.test(watch("contact_no") || "")
                  }
                  onClick={handleSendOtp}
                  btnText={
                    otpSending
                      ? "Sending..."
                      : otpSent
                      ? "OTP Sent"
                      : "Send OTP"
                  }
                />
              )}
            </div>

            {errors?.contact_no && (
              <span className="text-danger">{errors?.contact_no?.message}</span>
            )}

            {/* OTP INPUTS - visible only until verification */}
            {otpSent && !otpVerified && (
              <div className="mt-3">
                <Form.Label>Enter OTP</Form.Label>

                <div className="d-flex align-content-center flex-wrap gap-3">
                  <OtpInput
                    value={otp}
                    onChange={(value) => {
                      const numericValue = value.replace(/\D/g, "").slice(0, 4);

                      setOtp(numericValue);
                      setOtpError("");
                    }}
                    numInputs={4}
                    renderSeparator={<span className="mx-1">-</span>}
                    renderInput={(props) => (
                      <input
                        {...props}
                        className="login_otp_input"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onKeyDown={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            ![
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                    inputStyle={{
                      width: "45px",
                      height: "45px",
                      margin: "0 5px",
                      textAlign: "center",
                    }}
                  />

                  {/* OTP error BELOW OTP inputs */}
                  {otpError && (
                    <div className="text-danger mt-2 w-100">{otpError}</div>
                  )}

                  <div className="w-100">
                    <Green_btn
                      disabled={otpVerifying || otp.length !== 4}
                      onClick={handleVerifyOtp}
                      btnText={otpVerifying ? "Verifying..." : "Verify OTP"}
                    />
                  </div>
                </div>
              </div>
            )}
          </Form.Group>
          {/* <Form.Group className="gray_input_group input_group">
            <Form.Label className="label_text">Password</Form.Label>
            <div className="password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                name="password"
                {...register("password", {
                  required: "Password is required",
                  // minLength: {
                  //   value: 8,
                  //   message: "Password must be at least 8 characters long",
                  // },

                  maxLength: {
                    value: 100,
                    message: "Password cannot exceed 100 characters",
                  },

                  // pattern: {
                  //   value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                  //   message:
                  //     "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                  // },

                  validate: (value) =>
                    !/\s/.test(value) || "Password cannot contain spaces",
                  onChange: (e) => {
                    const value = e.target.value.replace(/\s/g, "");

                    setPassword(value);

                    setValue("password", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                })}
              />
              {errors?.password && (
                <sup className="text-danger">{errors?.password?.message}</sup>
              )}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
              </div>
            </div>
          </Form.Group>

          <Form.Group className="gray_input_group input_group">
            <Form.Label className="label_text">Confirm Password</Form.Label>
            <div className="password_holder">
              <Form.Control
                type={showPasswordOne ? "text" : "password"}
                name="re_password"
                placeholder="Enter Confirm Password"
                {...register("re_password", {
                  required: "Confirm Password is required",
                  validate: (value) =>
                    !/\s/.test(value)
                      ? value === getValues("password") ||
                        "Passwords do not match"
                      : "Confirm Password cannot contain spaces",
                  onChange: (e) => {
                    const value = e.target.value.replace(/\s/g, "");

                    setPasswordAgain(value);

                    setValue("re_password", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });

                    trigger("re_password");
                  },
                })}
              />

              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="icon"
                  onClick={() => togglePasswordVisibility("reenterPassword")}
                />
              </div>
              {errors?.re_password && (
                <sup className="text-danger">
                  {errors?.re_password?.message}
                </sup>
              )}
            </div>
          </Form.Group> */}

          {/* {password && (
            <div className="password_check_list">
              <PasswordChecklist
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => { }}
                style={{
                  fontSize: "10px",
                  padding: "4px",
                  margin: "0",
                }}
              />
            </div>
          )} */}
        </Form>
      </div>

      <div className="btn_holder">
        {/* <Green_btn
          btnText={isSigningUp ? "Signing Up..." : "Sign Up"}
          onClick={isSigningUp ? undefined : handleSubmit(onSubmit)}
          disabled={isSigningUp}
          // type="submit"
          // onClick={() => {
          //     props?.onHide()
          //     props?.setShowAccountCreted()
          //  }}
        /> */}

        <Green_btn
          btnText={isSigningUp ? "Signing Up..." : "Sign Up"}
          onClick={
            isSigningUp || !otpVerified ? undefined : handleSubmit(onSubmit)
          }
          disabled={isSigningUp || !otpVerified}
        />
      </div>

      <p className="dark_text">
        Already have an account?{" "}
        <span
          className="link_text"
          onClick={() => {
            setShowSignUp(false);
          }}
        >
          Log In
        </span>
        .
      </p>

      {/* <div className="or_text_div">
        <p className="or_txt">Or</p>
      </div>

      <div className="google_img_holder">
        <div className="img_holder">
          <img src="/assets/images/modal/google.png" className="g_img" />
        </div>
        <p className="signu_with_g_txt">Sign Up with Google</p>
      </div> */}
    </div>
  );
};

export default SignUp_Modal;
